import type { AppointmentType } from '@bb/domain/dist/types';

export const HOME_INSPECTION_TYPES: (
  | AppointmentType
  | 'Information Request'
)[] = [
  'Whole-Home Inspection',
  'Chimney Inspection',
  'Foundation Inspection',
  'Mold Inspection',
  'Pest Inspection',
  'Plumbing Inspection',
  'Roof Inspection',
  'Septic Inspection',
  'Site Measurement Inspection',
  'Radon Pickup',
  'Radon Drop Off',
];

export type T_HOME_INSPECTION_TYPES =
  | 'Whole-Home Inspection'
  | 'Chimney Inspection'
  | 'Foundation Inspection'
  | 'Mold Inspection'
  | 'Pest Inspection'
  | 'Plumbing Inspection'
  | 'Roof Inspection'
  | 'Septic Inspection'
  | 'Site Measurement Inspection'
  | 'Radon Pickup'
  | 'Radon Drop Off';
